import React, { useEffect } from "react";
import { Typography, Row, Col } from "antd";
import styles from "./form.module.less";
import FixedSpinner from "../FixedSpinner";

const { Title, Paragraph } = Typography;

const WithFormLayout = props => {
    const { loading = false, splitLayout = true, summary, title, subTitle, children } = props;
    useEffect(() => {
        window.scrollTo(0, 0)
    }, []);
    return (
        <FixedSpinner loading={loading} size="large">
            <div className={styles.formSelector}>
                <div>
                    <Row
                        gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}
                        style={{ margin: "0 auto" }}
                        align={"top"}
                        justify={"center"}
                        type={"flex"}
                    >
                        <Col
                            xs={{ span: 24, order: 2 }}
                            md={{ span: 12, order: 1 }}
                            style={{
                                marginBottom: "1.5rem",
                                textAlign: "center",
                                maxWidth: "500px",
                            }}
                        >
                            <Title level={2}>{title}</Title>
                            <Paragraph type="secondary">{subTitle}</Paragraph>
                            {children}
                        </Col>
                        {splitLayout && (
                            <Col
                                xs={{ span: 24, order: 1 }}
                                md={{ span: 12, order: 2 }}
                                style={{
                                    marginBottom: "1.5rem",
                                    maxWidth: "500px",
                                }}
                            >
                                {summary}
                            </Col>
                        )}
                    </Row>
                </div>
            </div>
        </FixedSpinner>
    );
};
export default WithFormLayout;
